import { IDEConsoleConfig, ValidationRule } from '../types';
import { getDefaultValidationRules } from './validationRules';

export const createDefaultConfig = (language: 'javascript' | 'python'): IDEConsoleConfig => {
  return {
    language,
    initialCode: getDefaultInitialCode(language),
    validationRules: getDefaultValidationRules(language),
  };
};

export const getDefaultInitialCode = (language: 'javascript' | 'python'): string => {
  // Return empty workspace for both languages
  return '';
};

export const createValidationRule = (
  id: string,
  type: 'syntax' | 'function' | 'import' | 'output' | 'pattern',
  condition: string,
  message: string,
  language: 'python' | 'javascript' = 'python',
  severity: 'error' | 'warning' = 'error',
  required: boolean = true
): ValidationRule => {
  return {
    id,
    type,
    condition,
    message,
    language,
    severity,
    required,
  };
};

// Re-export the new validation function for backward compatibility
export { validateCodeWithRules as validateCode } from './validation';


